import { BuyButton } from "@/components/BuyButton";
import { trackEvent } from "@/lib/api";

// Mobile-only sticky purchase bar. Routes through the same configurable checkout
// BuyButton logic (graceful \"checkout opening soon\" when URL is unset). Hidden on
// >= sm so it never covers desktop content or form buttons. On mobile it sits at
// the bottom; pages with primary form actions (e.g. Contact) intentionally omit it.
export default function StickyMobileCta({ source = "sticky_mobile" }) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 sm:hidden">
      <div className="border-t border-[color:rgba(231,190,74,0.25)] bg-[var(--ibp-navy-950)]/95 px-3 pb-[calc(env(safe-area-inset-bottom,0px)+10px)] pt-2.5 shadow-[0_-8px_24px_rgba(7,20,39,0.28)] backdrop-blur">
        <BuyButton
          testId="sticky-mobile-buy"
          fullWidth
          size="default"
          onClick={() => trackEvent("checkout_click", { source })}
        />
      </div>
    </div>
  );
}
